import { Pipe, PipeTransform } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'gender',
  standalone: false,
})
export class GenderPipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) { }

  transform(value: string): any {
    let type: string = '';

    switch (value) {
      case AppConst.GENDER_MALES:
        type = this.translate.instant('男性');
        break;
      case AppConst.GENDER_FEMALES:
        type = this.translate.instant('女性');;
        break;
      case AppConst.GENDER_NOANSWERS:
        type = this.translate.instant('答えたくない');;
        break;
    }
    return type;
  }

}
